import { Modelo } from '@ext/index';
import * as Types from './Cliente.types';
import moment, { Moment } from 'moment';

export class ICliente extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Persona: Types.Personas = Types.Personas.Fisica;
    public Tipo: string = 'minorista';

    public Cuenta: number = 0;
    public UsuarioMercadolibre: number = 0;

    public RazonSocial: string = '';
    public Nombre: string = '';
    public Apellido: string = '';
    public TipoDocumento: string = 'DNI';
    public Documento: string = '';
    public Cuit: string = '';

    public CondicionIva: Types.Condiciones = Types.Condiciones.ConsumidorFinal;

    public Direccion: Direccion = new Direccion();
    public Contacto: Contacto = new Contacto();


    public getJson(): any {
        let json: any = {};
        json.id = this.Id;
        json.persona = this.Persona.Id;
        json.tipo = this.Tipo;
        json.cuenta = this.Cuenta;
        json.usuario_mercadolibre = this.UsuarioMercadolibre;
        json.razon_social = this.RazonSocial;
        json.nombre = this.Nombre;
        json.apellido = this.Apellido;
        json.tipo_documento = this.TipoDocumento;
        json.documento = this.Documento;
        json.cuit = this.Cuit;
        json.condicion_iva = this.CondicionIva.Id;
        json.calle = this.Direccion.Calle;
        json.numero = this.Direccion.Numero;
        json.departamento = this.Direccion.Departamento;
        json.piso = this.Direccion.Piso;
        json.localidad = this.Direccion.Localidad;
        json.codigo_postal = this.Direccion.CodigoPostal;
        json.provincia = this.Direccion.Provincia;
        json.pais = this.Direccion.Pais;
        json.telefono = this.Contacto.Telefono;
        json.celular = this.Contacto.Celular;
        json.email = this.Contacto.Email;

        return json;
    }


    public set(): boolean {


        this.Id = !this.Json.id ? 0 : this.Json.id;

        this.Persona = Types.Personas.toTipo( this.Json.persona );
        this.CondicionIva = !this.Json.condicion_iva ? Types.Condiciones.ConsumidorFinal : Types.Condiciones.toTipo( this.Json.condicion_iva );

        this.Tipo = !this.Json.tipo ? '' : this.Json.tipo;
        this.Cuenta = !this.Json.cuenta ? 0 : this.Json.cuenta;
        this.UsuarioMercadolibre = !this.Json.usuario_mercadolibre ? 0 : this.Json.usuario_mercadolibre;
        this.RazonSocial = !this.Json.razon_social ? '' : this.Json.razon_social;
        this.Nombre = !this.Json.nombre ? '' : this.Json.nombre;
        this.Apellido = !this.Json.apellido ? '' : this.Json.apellido;
        this.TipoDocumento = !this.Json.tipo_documento ? '' : this.Json.tipo_documento;
        this.Documento = !this.Json.documento ? '' : this.Json.documento;
        this.Cuit = !this.Json.cuit ? '' : this.Json.cuit;

        this.Direccion.Calle = !this.Json.calle ? '' : this.Json.calle;
        this.Direccion.Numero = !this.Json.numero ? '' : this.Json.numero;
        this.Direccion.Departamento = !this.Json.departamento ? '' : this.Json.departamento;
        this.Direccion.Piso = !this.Json.piso ? '' : this.Json.piso;
        this.Direccion.Localidad = !this.Json.localidad ? '' : this.Json.localidad;
        this.Direccion.CodigoPostal = !this.Json.codigo_postal ? '' : this.Json.codigo_postal;
        this.Direccion.Provincia = !this.Json.provincia ? '' : this.Json.provincia;
        this.Direccion.Pais = !this.Json.pais ? '' : this.Json.pais;
        this.Contacto.Telefono = !this.Json.telefono ? '' : this.Json.telefono;
        this.Contacto.Celular = !this.Json.celular ? '' : this.Json.celular;
        this.Contacto.Email = !this.Json.email ? '' : this.Json.email;

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: ICliente ) {
        this.Model = Model;
    }

    public Model: ICliente;
    public get Descripcion(): string {
        return this.Model.RazonSocial ? this.Model.RazonSocial : ( this.Model.Nombre ? this.Model.Nombre : '' ) + ( this.Model.Apellido ? ' ' + this.Model.Apellido : '' );
    }
}



class Direccion {

    public Calle: string = '';
    public Numero: string = '';
    public Departamento: string = '';
    public Piso: string = '';
    public Localidad: string = '';
    public CodigoPostal: string = '';
    public Provincia: string = '';
    public Pais: string = 'ARGENTINA';

    public get Linea(): string {
        return this.Calle + ' ' + this.Numero + ' ' + this.Piso + this.Departamento + ' ' + this.Localidad + ' ' + this.CodigoPostal + ' ' + this.Provincia;
    }

    public get Valida(): boolean {
        let e = !this.Calle || !this.Localidad || !this.Provincia;
        return !e;
    }
}

class Contacto {

    public Telefono: string = '';
    public Celular: string = '';
    public Email: string = '';
}